export default "__VITE_ASSET__v3lhk5FT__"